module.exports = jQuery;